import {useMemo} from "react";

export function useOrderId() {
    return useMemo(() => {
        const splittingHref = window.location.href.split("/");
        return splittingHref[splittingHref.length - 1];
    }, [window.location.href]);
}

export function useCid() {
    return useMemo(() => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get('cid') || '';
    }, []);
}